import {useQuery} from '@tanstack/react-query'
import Constants from "../config/constants";

export function useLocale(url, options) {
    options.cacheTime = Infinity;
    options.queryKey = [url, Constants.SW_VERSION];

    return useQuery(options)
}